import { HttpClient } from '@angular/common/http';
import { ResponseCasingEnum } from './response-enum';

export interface MyHttpClientFactoryOptions {
  /**
   * Revive ISO date strings in JSON responses to `Date`. Default `true`; pass `false` to disable.
   */
  reviveDates?: boolean;
  /**
   * Rewrite `Date` in POST/PUT/PATCH bodies to local wire strings (no `Z`). Default `true`; pass `false` to disable.
   */
  localCalendarDateBody?: boolean;
}

export interface IMyHttpClientFactory {
  createHttpClient(
    baseUrl: string,
    auth: boolean,
    casing: ResponseCasingEnum,
    options?: MyHttpClientFactoryOptions
  ): HttpClient;
}
